/** Best effort only. Serialize writes and coalesce intermediate positions so a
 * slow response cannot let an older request overwrite the latest displayed page.
 * The caller never waits and failures never escape into learner-facing UI. */
export function createModulePositionWriter(save: (fragmentKey: string) => Promise<void>) {
    let pending: string | null = null;
    let lastQueued: string | null = null;
    let running = false;
    async function drain() {
        while (pending !== null) {
            const fragment = pending;
            pending = null;
            try { await save(fragment); } catch { /* Resume metadata must not interrupt learning. */ }
        }
        running = false;
    }
    return (fragment: string) => {
        if (!fragment || (running && fragment === lastQueued)) return;
        lastQueued = fragment;
        pending = fragment;
        if (!running) {
            running = true;
            void drain();
        }
    };
}
